import React, { useEffect, useRef, useState, useCallback, useContext } from 'react';
import Account from '../../../API/APIServices/Account';
import AccountGroup from '../../../API/APIServices/AccountGroup';
import CustomizeDeleteService from '../../../API/APIServices/CustomizeDeleteService';
import { radians } from 'pdf-lib';
import ConfirmDeletionWithUserInput from '../../Props/ConfirmDeletionWithUserInput';
import MyContext from '../../MyContext';

function AccountCustomizeDelete({ setLoading }) {

    const [accountList, setAccountList] = useState([]);
    const [accountGroupList, setAccountGroupList] = useState([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(1);
    const [pageGroup, setPageGroup] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalRecordsGroup, setTotalRecordsGroup] = useState(0);
    const [selectAccountGroup, seSelectAccountGroup] = useState(0);
    const [isAccountGroupShow, setIsAccountGroupShow] = useState(false);
    const [isSoftDelete, setIsSoftDelete] = useState(true);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [isDropdownAccountName, setIsDropdownAccountName] = useState(false);
    const [isDropdownAccountGroupName, setIsDropdownAccountGroupName] = useState(false);
    const [accountSuggestion, setAccountSuggestion] = useState([]);
    const [accountGroupSuggestion, setAccountGroupSuggestion] = useState([]);
    const [accountName, setAccountName] = useState("");
    const [accountGroupName, setAccountGroupName] = useState("");
    const [selectedAccountName, setSelectedAccountName] = useState("");
    const [selectedAccountGroupName, setSelectedAccountGroupName] = useState("");
    const [accountId, setAccountId] = useState(0);
    const [accountGroupId, setAccountGroupId] = useState(0);

    const dropDownRef = useRef(null);
    const { debounce } = useContext(MyContext);


    async function fetchData(page_num, account_id, account_group_id) {

        setLoading(true);

        try {

            let filterToSend = [];

            if (account_id) {

                filterToSend.push({
                    "fieldName": "d2Id",
                    "operatorName": "equal",
                    "compareValue": account_id
                });

            }

            if (account_group_id) {

                filterToSend.push({
                    "fieldName": "parentGroupId",
                    "operatorName": "equal",
                    "compareValue": account_group_id
                });

            }

            const filter = {
                "filter": filterToSend,
                "order": [
                    {
                        "propertyName": "string",
                        "ascending": true
                    }
                ],
                "pageNumber": page_num,
                "pageSize": pageSize
            };

            const response = await Account.getAccountWithFilter2(filter);

            if (response.data.isSuccess) {

                const list = response.data.result.map((item) => {

                    item.isSelected = false;
                    return item;
                });

                setAccountList(list);
                setTotalRecords(response.data.totalRecords);
            } else {
                console.log("Error when fetching account", response?.data?.errorMessages);
            }
        } catch (error) {
            console.log("Error when fetching account", error?.response?.data?.errorMessages);
        }
        setLoading(false);
    }

    async function fetchAccountGroup(page_num) {

        const filter = {
            "filter": [
                {
                    "fieldName": "string",
                    "operatorName": "string",
                    "compareValue": "string"
                }
            ],
            "order": [
                {
                    "propertyName": "string",
                    "ascending": true
                }
            ],
            "pageNumber": page_num,
            "pageSize": pageSize
        };

        try {
            const response = await AccountGroup.GetAccountGroupsFilter2(filter);

            if (response.data.isSuccess) {

                const list = response.data.result.map((item) => {

                    item.isSelected = false;
                    return item;
                });

                setTotalRecordsGroup(response.data.totalRecords);
                setAccountGroupList(list);
            } else {
                console.log("Error When Fetching Account Group:", response.data.errorMessages);
            }

        } catch (error) {
            console.log("Error When Fetching Account Group:", error?.response.data.errorMessages);
        }

    }

    useEffect(() => {

        console.log("accountGroupList", accountGroupList);
    }, [accountGroupList]);

    useEffect(() => {

        console.log("accountList", accountList);
    }, [accountList]);

    useEffect(() => {
        // fetchAccountGroup(pageGroup);
    }, [pageGroup]);

    useEffect(() => {
        fetchData(page, accountId, accountGroupId);
    }, [page, accountId, accountGroupId]);

    function handlePrevClick() {

        if (page <= 1) return;

        setPage(page - 1);
    }

    function handleNextClick() {

        if (page >= Math.ceil(totalRecords / pageSize)) return;

        setPage(page + 1);
    }

    function handleAccountSelect(e, index) {

        const bool = e.target.checked;
        const tempAccountList = [...accountList];

        tempAccountList[index].isSelected = bool;
        setAccountList(tempAccountList);
    }

    function handleAccountGroupSelect(e, index) {

        const { checked, value } = e.target;
        const tempAccountGroupList = [...accountGroupList];

        tempAccountGroupList[index].isSelected = checked;

        setAccountGroupList(tempAccountGroupList);
    }

    async function handleDelete() {

        setConfirmDeleteOpen(false);
        setLoading(true);

        try {

            // const accountGroups_D2Id = accountGroupList.filter(item => item.isSelected).map(item => item.id);
            const acounts_D2Id = accountList.filter(item => item.isSelected).map(item => item.d2Id);

            const data = {
                "accountGroups_D2Id": [accountGroupId],
                "acounts_D2Id": acounts_D2Id,
                "softDelete": isSoftDelete
            }

            const response = await CustomizeDeleteService.DeleteAccountsAsync(data);

            if (response.data.isSuccess) {

                fetchData(page, accountId, accountGroupId);
                // fetchAccountGroup(pageGroup);
                alert("Account Deleted Successfully!");

            } else {
                console.log("Error in Account Custom Delete", response?.data?.errorMessages);
                alert("Failed to delete!")
            }

        } catch (e) {
            console.log("Error in Account Custom Delete", e?.response?.data?.errorMessages);
            alert("Failed to delete!")
        }

        setLoading(false);
    }

    function handlePrevClickGroup() {

        if (pageGroup <= 1) return;

        setPageGroup(pageGroup - 1);
    }

    function handleNextClickGroup() {

        if (pageGroup >= Math.ceil(totalRecordsGroup / pageSize)) return;

        setPageGroup(pageGroup + 1);
    }

    const fetchSuggestions = async (name, value, GroupId, MasterType) => {

        const filteredData = {
            MasterType: MasterType,
            GroupWiseSuggestion: true,
            GroupId: GroupId,
            search_str: value,
            PageNumber: 1,
            PageSize: 50,
        };

        try {
            const SearchItem = await Account.GetAccountListForAutoSuggestion(
                filteredData
            );

            if (SearchItem) {
                return SearchItem;
            } else {
                return [];
            }
        } catch (error) {
            console.error("Error fetching account suggestions:", error);
            return [];
        }
    };

    const debouncedFetchAccountSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 2);

            setAccountSuggestion(SearchItem);
            setIsDropdownAccountName(true);

        }, 500),
        []
    );

    const debouncedFetchAccountGroupSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 1);

            setAccountGroupSuggestion(SearchItem);
            setIsDropdownAccountGroupName(true);

        }, 500),
        []
    );

    const handleAccountNameChange = (e) => {

        setAccountName(e.target.value);
        setSelectedAccountName("");
        setAccountId(0);
        debouncedFetchAccountSuggestions("AccountName", e.target.value, '');
    }

    const handleAccountNameSelection = async (id, name) => {

        console.log(id, name)
        setAccountName(name);
        setAccountId(id);
        setSelectedAccountName(name);
        setIsDropdownAccountName(false);
    };

    const handleAccountGroupNameChange = (e) => {

        setAccountGroupName(e.target.value);
        setSelectedAccountGroupName("");
        setAccountGroupId(0);
        debouncedFetchAccountGroupSuggestions("AccountGroupName", e.target.value, '');
    }

    const handleAccountGroupNameSelection = async (id, name) => {

        console.log(id, name)
        setAccountGroupName(name);
        setAccountGroupId(id);
        setSelectedAccountGroupName(name);
        setIsDropdownAccountGroupName(false);
    };

    useEffect(() => {

        function handleClickOutside(event) {

            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setIsDropdownAccountGroupName(false);
                setIsDropdownAccountName(false);
            }
        }


        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);


    return (
        <div className="padding-20">

            <div>
                <div className="company_info-text-im relative" style={{ height: "60px", zIndex: 5 }}>


                    <div className='customize-delete-button customize-delete-heading-select' style={{ left: "10px" }}>

                        <div >Account Deletion</div>

                    </div>

                    <button onClick={() => setConfirmDeleteOpen(!confirmDeleteOpen)} className="product-price-account-wise-delete-button customize-delete-button">Delete</button>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "10px" }}>
                    <input
                        type="checkbox"
                        name="showPrintOptionPopup"
                        checked={isSoftDelete}
                        onChange={((e) => setIsSoftDelete(e.target.checked))}
                        className="toggle-input"
                        style={{}}
                    />

                    <span>Soft Delete</span>
                </div>

                <div className="search_panel_hd1">
                    <div style={{ width: "60%" }}>
                        <div ref={dropDownRef} className="col-sm-n1" style={{ width: "100%", alignItems: "center", justifyContent: "center" }}>

                            <div className="group_head" style={{ position: "relative" }}>
                                {/* <svg className="search_panel_icon" aria-hidden="true" viewBox="0 0 24 24"><g><path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path></g></svg> */}
                                <input style={{ width: "90%" }} value={accountName} onChange={handleAccountNameChange} onClick={() => {

                                    setIsDropdownAccountGroupName(false);
                                    debouncedFetchAccountSuggestions("AccountName", accountName, '')
                                }
                                } placeholder="Account Name" type="text" className="bill_panel_input" />


                                {isDropdownAccountName && (
                                    <ul
                                        style={{ position: "absolute", top: "35px" }}
                                        className="ItemmasterDuggestionsaleinvoice"

                                    >
                                        {accountSuggestion.map((aName, index) => (
                                            <li
                                                key={index}

                                                onClick={() =>
                                                    handleAccountNameSelection(
                                                        aName.id,
                                                        aName.name
                                                    )
                                                }
                                            >
                                                {aName.name}
                                            </li>
                                        ))}
                                    </ul>
                                )}

                            </div>

                            <div className="group_head" style={{ position: "relative" }}>
                                <input style={{ width: "90%" }} value={accountGroupName} onChange={handleAccountGroupNameChange} onClick={() => {

                                    setIsDropdownAccountName(false);
                                    debouncedFetchAccountGroupSuggestions("AccountGroupName", accountGroupName, '')
                                }
                                } placeholder="Account Group Name" type="text" className="bill_panel_input" />


                                {isDropdownAccountGroupName && (
                                    <ul
                                        style={{ position: "absolute", top: "35px" }}
                                        className="ItemmasterDuggestionsaleinvoice"

                                    >
                                        {accountGroupSuggestion.map((agName, index) => (
                                            <li
                                                key={index}

                                                onClick={() =>
                                                    handleAccountGroupNameSelection(
                                                        agName.id,
                                                        agName.name
                                                    )
                                                }
                                            >
                                                {agName.name}
                                            </li>
                                        ))}
                                    </ul>
                                )}

                            </div>

                        </div>
                    </div>


                </div>

                <div className="customize-delete-table-overflow">
                    <table className="lens-stock-table">

                        <thead>
                            <tr>

                                <th style={{ width: "50px" }} className="lens-stock-table-th">S.No.</th>
                                <th style={{ width: "50px" }} className="lens-stock-table-th">Select</th>
                                <th className="lens-stock-table-th">Account Id</th>
                                <th className="lens-stock-table-th">Name</th>
                                <th className="lens-stock-table-th">Account Group</th>
                                <th className="lens-stock-table-th">State Name</th>

                            </tr>
                        </thead>

                        <tbody>

                            {accountList.map((item, index) => {

                                if (index % 2 === 0) {

                                    return (

                                        <tr key={index} className="TrLensCreation" style={item.isSelected ? { backgroundColor: "#beddfc" } : {}}>

                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{((page - 1) * pageSize) + index + 1}</td>

                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                                <input checked={item.isSelected} onChange={(e) => handleAccountSelect(e, index)} type="checkbox" />
                                            </td>
                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.d2Id || ""}</td>
                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.printName || item.name || ""}</td>
                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.parentGroupName || ""}</td>
                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.stateName || ""}</td>
                                        </tr>
                                    );

                                } else {

                                    return (

                                        <tr key={index} className="TrLensCreation customize-delete-alternate-color" style={item.isSelected ? { backgroundColor: "#beddfc" } : {}}>

                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{((page - 1) * pageSize) + index + 1}</td>

                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                                <input checked={item.isSelected} onChange={(e) => handleAccountSelect(e, index)} type="checkbox" />
                                            </td>
                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.d2Id || ""}</td>
                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.printName || item.name || ""}</td>
                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.parentGroupName || ""}</td>
                                            <td style={{ backgroundColor: "inherit" }} className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.stateName || ""}</td>
                                        </tr>
                                    );

                                }

                            })}

                        </tbody>
                    </table>
                </div>


                <div style={{ backgroundColor: "#E1EFFD", justifyContent: "end", marginTop: "5px", padding: "10px 0px", borderRadius: "4px" }} className="flex">

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "25%" }}>
                        <button disabled={page <= 1 ? true : false} onClick={handlePrevClick} class="table-list-button">
                            <i class="fa-solid fa-chevron-left"></i>
                        </button>
                        <span class="table-list-page-txt">Page - <strong style={{ margin: "0px 3px;" }}>{page} of {Math.ceil(totalRecords / pageSize)}</strong></span>
                        <button disabled={page >= Math.ceil(totalRecords / pageSize) ? true : false} onClick={handleNextClick} class="table-list-button">
                            <i class="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>

                </div>

                {/* <div style={{ marginTop: "10px" }} className='company_info-text-im'>

                    Account Group Wise Deletion
                </div>

                <div className="customize-delete-table-overflow">
                    <table className="lens-stock-table">

                        <thead>
                            <tr>

                                <th style={{ width: "50px" }} className="lens-stock-table-th">S.No.</th>
                                <th style={{ width: "50px" }} className="lens-stock-table-th">Select</th>
                                <th className="lens-stock-table-th">Account Group Id</th>
                                <th className="lens-stock-table-th">Account Group Name</th>

                            </tr>
                        </thead>

                        <tbody>

                            {accountGroupList.map((item, index) => (

                                <tr key={index} className="TrLensCreation">

                                    <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{((pageGroup - 1) * pageSize) + index + 1}</td>

                                    <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">
                                        <input onChange={(e) => handleAccountGroupSelect(e, index)} checked={item.isSelected} value={item.id} type="checkbox" />
                                    </td>
                                    <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.id || ""}</td>
                                    <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1 customize-delete-table-td">{item.printName || item.name || ""}</td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>


                <div style={{ backgroundColor: "#E1EFFD", justifyContent: "end", marginTop: "5px", padding: "10px 0px", borderRadius: "4px" }} className="flex">

                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "25%" }}>
                        <button disabled={pageGroup <= 1 ? true : false} onClick={handlePrevClickGroup} class="table-list-button">
                            <i class="fa-solid fa-chevron-left"></i>
                        </button>
                        <span class="table-list-page-txt">Page - <strong style={{ margin: "0px 3px;" }}>{pageGroup} of {Math.ceil(totalRecordsGroup / pageSize)}</strong></span>
                        <button disabled={pageGroup >= Math.ceil(totalRecordsGroup / pageSize) ? true : false} onClick={handleNextClickGroup} class="table-list-button">
                            <i class="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>

                </div> */}


            </div>

            {confirmDeleteOpen && <ConfirmDeletionWithUserInput
                HeadingTop="Are you sure you want to delete!"
                closeButtonClick={() => { setConfirmDeleteOpen(false) }}
                onYesClick={handleDelete}
            />}

        </div>
    );
}

export default AccountCustomizeDelete;